import { render } from "./InternalOrExternalLink.vue?vue&type=template&id=9bfe62fc&scoped=true"
import script from "./InternalOrExternalLink.vue?vue&type=script&lang=js"
export * from "./InternalOrExternalLink.vue?vue&type=script&lang=js"

import "./InternalOrExternalLink.vue?vue&type=style&index=0&id=9bfe62fc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bfe62fc"]])

export default __exports__